import { Container, Flex, FlexProps } from '@chakra-ui/react';

export default function FixedBar({ children, ...props }: FlexProps) {
  return (
    <Flex
      boxShadow="0px 24px 56px -4px rgba(88, 92, 95, 0.39)"
      bgColor="white"
      pos="fixed"
      w="full"
      left={0}
      bottom={0}
      zIndex={10}
      {...props}
    >
      <Container 
        variant="internal"
        py="18px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {children}
      </Container>
    </Flex>
  )
}
